import React from "react";
import "./Campus.css";
import { connect } from "react-redux";
import {
  createCampus,
  updateCampus,
  deleteCampus,
  addCampusToPersonnel,
} from "../../redux/college/college.actions";

import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import ButtonContainer from "../../Components/CheckableButton/ButtonContainer";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import FormField from "../../Components/FormField/FormField";
import FormDropdown from "../../Components/FormField/FormDropdown";
import CancelButton from "../../Components/Buttons/CancelButton";
import { notify } from "react-notify-toast";
import Modal from "../../Components/Modal/Modal";
import { API } from "../../API";
import { Placeholder } from "semantic-ui-react";
import TimezoneSelect from "react-timezone-select";
import { Country, City, State }  from 'country-state-city';
import uuid from "uuid/v4";
import axios from "axios";
import GgMap from '../../Components/Map/GgMap'
import GoogleMapsAutocomplete from '../../Components/Map/AutocompleteLocation'
import { Button } from "@mui/material";
import { GOOGLE_MAP_API_KEY } from "../../Helper";

const defaultTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
const countries = Country.getAllCountries();

class Campus2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // campuses: [],
      current_campus: null,
      _id: "",
      campus_shortname: "",
      address_line1: "",
      address_line2: "",
      suburb: "",
      state: "",
      postcode: "",
      country: "",
      country_code: "",
      cities: [],
      induction_module_link: "",
      extra_booking_email: "",
      floor_no: "",
      note_gcal: "",
      report_to: "",
      reference_name: "",
      departments: "",
      customer_id: "",
      customer: "",
      // campuses: "",
      isShowing: false,
      newCampuses: [],
      mobileCam: props.mobileCam,
      editthiscampus: false,
      timezone: defaultTZ,
      edited: false,
      car_parking: "",
      car_parking_location: {
        address: "",
        lat: 0,
        lng: 0,
        detail: "",
      },
      detail: "",
      current_coords: {
        lat: 0,
        lng: 0
      },
    };
  }

  addNewCampus = () => {
    const fullcontrol = !this.props.user.permissions;
    const campusDefaultData = {
      _id: null,
      temp_id: uuid(),
      campus_shortname: "",
      address_line1: "",
      address_line2: "",
      suburb: "",
      state: "",
      postcode: "",
      country: "",
      induction_module_link: "",
      extra_booking_email: "",
      floor_no: "",
      note_gcal: "",
      report_to: "",
      reference_name: "",
      departments: [],
      timezone: "",
      current_campus: "",
      editthiscampus: "",
      country_code: "",
      cities: [],
      current_coords: {
        lat: 0,
        lng: 0,
      },
      car_parking: "",
      car_parking_location: {
        lat: 0,
        lng: 0,
        address: "",
        detail: "",
      }
    }
    if (this.props.editcampus) {
      if (fullcontrol) {
        // if customer
        const newCampusData = {
          ...campusDefaultData,
          customer_id: this.props.user.customer_id,
          institution_id: this.props.user.institution_id
        }
        // this.props.createCampus(newCampusData);
        var temp = this.state.newCampuses;
        temp.push(newCampusData);
        this.setState(
          {
            newCampuses: temp,
            current_campus: newCampusData,
          },
          () => {
            console.log("new campus created", newCampusData);
            this.setFieldsValue(newCampusData);
          }
        );
      } else {
        console.log("Adding campus by personnel")
        const newCampusData = {
          ...campusDefaultData,
          personnel_id: this.props.user.personnel_id,
          institution_id: this.props.institution._id
        }
        var temp = this.state.newCampuses;
        temp.push(newCampusData);
        this.setState(
          {
            newCampuses: temp,
            current_campus: newCampusData,
          },
          () => {
            console.log("new created by personnel", newCampusData);
            this.setFieldsValue(newCampusData);
            // window.location.reload(false);
          }
        );
        // API.createCampusByPersonnel({
        //   personnel_id: this.props.user.personnel_id,
        //   institution_id: this.props.institution._id,
        // }).then((res) => {
        //   // this.props.addCampusToPersonnel(res.data);
          
        // });
      }
    } else {
      notify.show(
        "Please contact your manager to acquire access to manage campus"
      );
    }
  };

  setFieldsValue = (current_campus) => {
    if (this.state.mobileCam) {
      current_campus = this.state.mobileCam;
    }
    // console.log('current_campus', current_campus)
    var _id = current_campus._id;
    var campus_shortname = current_campus.campus_shortname;
    var address_line1 =
      current_campus.address_line1 === null ? "" : current_campus.address_line1;
    var address_line2 = current_campus.address_line2;
    var suburb = current_campus.suburb;
    var state = current_campus.state;
    var postcode = current_campus.postcode;
    var country = current_campus.country;
    let country_code = countries.find((country) => {
      if(current_campus.country === country.name) {
        return country.isoCode;
    }});
    if(!country_code) {
      countries.push({currency: "", flag: "", state: "", postcode: "", 
      name: current_campus.country, phonecode: "", isoCode: "", latitude: "", longitude: ""})
    }
    let cities = [];
    if(country_code) {
      cities = State.getStatesOfCountry(country_code.isoCode)
      let checkCityInArray = cities.find((city) => {
        if(current_campus.state === city.name) {
          return city;
      }});
      if(!checkCityInArray) {
        cities.push({countryCode: "AU", latitude:  0, longitude: 0,name: current_campus.state, stateCode: null})
      }
    }
    var induction_module_link = current_campus.induction_module_link;
    var extra_booking_email =
      current_campus.extra_booking_email === null
        ? ""
        : current_campus.extra_booking_email;
    var floor_no = current_campus.floor_no;
    var note_gcal = current_campus.note_gcal;
    var report_to =
      "report_to" in current_campus
        ? current_campus.report_to
        : "no report_to filed";
    var reference_name =
      "reference_name" in current_campus
        ? current_campus.reference_name
        : "no ref_name filed";
    var departments = current_campus.departments;
    let timezone =
      (current_campus.timezone && current_campus.timezone.split(" ")[1]) ||
      current_campus.timezone ||
      defaultTZ;
    var editthiscampus =
      current_campus._id && this.props.user?.personnel_id ? (
      this.props.user?.campuses?.includes(current_campus._id)) : true;

    const car_parking = current_campus?.car_parking
    const car_parking_location = current_campus?.car_parking_location

    this.setState({
      _id,
      campus_shortname,
      address_line1,
      address_line2,
      suburb,
      state,
      postcode,
      country,
      induction_module_link,
      extra_booking_email,
      floor_no,
      note_gcal,
      report_to,
      reference_name,
      departments,
      timezone,
      current_campus,
      editthiscampus,
      country_code,
      cities,
      car_parking,
      car_parking_location
    });
  };

  swapTab = (key) => {
    if (key >= this.props.campuses.length) {
      localStorage.setItem("campus-Index", key);

      const current_campus = this.state.newCampuses[
        key - this.props.campuses.length
      ];
      this.setState(
        {
          current_campus: current_campus,
        },
        () => {
          this.setFieldsValue(current_campus);
        }
      );
    } else if (key === "addNew") {
      localStorage.setItem("campus-Index", 0);
      console.log("addNew: ", this.props.campuses, this.state)
      this.addNewCampus();
    } else {
      for (var i = 0; i < this.props.campuses.length; i++) {
        if (this.props.campuses[i]._id === key) {
          localStorage.setItem("campus-Index", i);
          const current_campus = this.props.campuses[i];
          this.setState(
            {
              current_campus: current_campus,
            },
            () => {
              this.setFieldsValue(current_campus);
            }
          );
          break;
        }
      }
    }
  };

  componentDidMount = () => {
    var index = 0;
    if (localStorage.getItem("campus-Index") !== null) {
      index = parseInt(localStorage.getItem("campus-Index"));
    }
    if (this.props.campuses.length > 0) {
      if (this.props.isViewAsAdmin) {
        this.swapTab(this.props.campuses[0]?._id);
      } else {
        this.swapTab(this.props.campuses[index]?._id || this.props.campuses[0]?._id);
      }
    }
    
    if (this.props?.user?.is_childcare_centre) {
      const currentCampus = this.props.campuses[index];
      const carParkingLocation = currentCampus?.car_parking_location

      if (currentCampus?.car_parking && carParkingLocation && carParkingLocation?.address) {
        this.setState({
          current_coords: {
            lat: carParkingLocation?.lat || 0,
            lng: carParkingLocation?.lng || 0
          },
        })
      }
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.user?.is_childcare_centre && prevState._id != this.state._id) {
      const currentCampus = this.state.current_campus
      if (currentCampus?.car_parking && currentCampus?.car_parking !== "On-site (free)") {
        this.setState({
          current_coords: {
            lat: currentCampus?.car_parking_location?.lat || 0,
            lng: currentCampus?.car_parking_location?.lng || 0,
          },
          car_parking_location: this.state.car_parking_location,
        })
      }
    }
  }

  handleDepartmentChange = (e) => {
    this.setState({ edited: true });
    if (e.target.checked) {
      this.state.departments.push(e.target.title);
      //console.log(this.state.departments)
      this.setState({
        departments: this.state.departments,
      });
    } else {
      const index = this.state.departments.indexOf(e.target.title);
      if (index > -1) {
        this.state.departments.splice(index, 1);
      }
      this.setState({
        departments: this.state.departments,
      });
    }
  };

  handleFormFieldChange = (e) => {
    this.setState({ [e.target.id]: e.target.value, edited: true });
  };

  onSelectCountry = (e) => {
    let setValue = countries.find((country) => {
      if(e.target.value === country.name) {
        return country.isoCode;
    }});
    let cities = State.getStatesOfCountry(setValue.isoCode);
    let campusState = this.state.current_campus.state;
    let checkCityInArray = cities.find((city) => {
      if(campusState === city.name) {
        return city;
    }});
    if(this.state.current_campus.country === setValue.name && !checkCityInArray) {
      cities.push({countryCode: "AU", latitude:  0, longitude: 0,name: this.state.current_campus.state, stateCode: null})
    }
    this.setState({ country_code: setValue });
    this.setState({ cities: cities });

    this.setState({ [e.target.id]: e.target.value, edited: true });
  }

  handleCarParkingChange = (e) => {
    this.setState({
      car_parking: e.target.title,
      edited: true
    })

    if (e.target.title !== "On-site (free)" && !this.state.current_campus?.car_parking_location?.address) {
      const currentCampus = this.state.current_campus
      const campusAddress = [
        currentCampus.address_line1 || currentCampus.address_line2 || "",
        currentCampus.suburb || "",
        currentCampus.state || "",
        currentCampus.country || "",
      ].filter(value => value)
      .join(", ")

      axios.get(`https://geocode.maps.co/search?q=${campusAddress}&api_key=66023dbe274e4579240802nek69315c`)
        .then((response) => {
          const data = response.data
          if (data?.[0]) {
            const addressObj = data?.[0]
            const coord = {
              lat: parseFloat(addressObj.lat),
              lng: parseFloat(addressObj.lon),
            }
            this.handleChangeCarParkingLocation({
              address: addressObj.display_name,
              ...coord
            })
            this.setState({
              current_coords: coord
            })
          }
        })
        .catch(err => {
          console.log(`⚡️[log]: †††††† ~ err: `, err);
        })
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const fields = [
      "address_line1",
      "suburb",
      "state",
      "postcode",
      "country",
      "floor_no",
      "note_gcal",
      "report_to",
      "extra_booking_email",
      "reference_name",
    ];
    let errors;

    for (let field of fields) {
      const input = document.getElementById(field);
      if (input) {
        if (!input.reportValidity()) {
          errors = true;
          break;
        } // at least one department needs to be checked
        else if (!this.props.user?.is_childcare_centre && this.state.departments.length === 0) {
          notify.show("Please add at least one department");
          errors = true;
        } else {
          errors = false;
        }
      }
    }
    const emailList = this.state.extra_booking_email.split(';');
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(emailList.length) {
      emailList.forEach(email => {
        if (email.trim() !== '' && !emailPattern.test(email.trim())) {
          notify.show("Invalid email. Please use the correct format and seperate each email by the semicolon");
          errors = true;
        }
      });
    }

    if (this.props.user?.is_childcare_centre && !this.state.car_parking) {
      notify.show("No parking provided");
      errors = true;
      return
    }

    if (
      this.props.user?.is_childcare_centre
      && this.state.car_parking
      && this.state.car_parking !== "On-site (free)"
      && !this.state.car_parking_location?.address?.trim().length
    ) {
      notify.show("Invalid car parking location. Please select GPS location");
      errors = true;
    }

    if (errors) {
      notify.show("You are missing one or more field(s)!");
      errors = true;
    } else if (!errors) {
      const updatingData = {
        _id: this.state.current_campus._id,
        campus_shortname: this.state.address_line1,
        report_to: this.state.report_to,
        floor_no: this.state.floor_no,
        address_line1: this.state.address_line1,
        address_line2: this.state.address_line2,
        suburb: this.state.suburb,
        state: this.state.state,
        postcode: this.state.postcode,
        country: this.state.country,
        note_gcal: this.state.note_gcal,
        extra_booking_email: this.state.extra_booking_email,
        reference_name: this.state.reference_name,
        departments: this.state.departments,
        timezone: this.state.timezone,
        car_parking: this.state.car_parking,
        car_parking_location: this.state.car_parking === "On-site (free)" ? "" : this.state.car_parking_location
      }
      if(!this.state.current_campus._id) {
        console.log("Create first")
        const fullcontrol = !this.props.user.permissions;
        if(this.props.user?.customer_id) {
          // customer
          API.createCampus({
            customer_id: this.props.user.customer_id,
            institution_id: this.props.user.institution_id,
          }).then((res) => {
            console.log("After created: ", res?.data)
            API.updateCampus({
              ...updatingData,
              _id: res?.data?._id
            }).then((response) => {
              console.log("Updated campus: ", response)
              this.props.createCampus(response?.data);
              const msg = "Campus created successfully";
              notify.show(msg);
              setTimeout(() => {
                window.location.reload();
              }, 700)
            })
          });
        }
        else {
          // personnel
          API.createCampusByPersonnel({
            personnel_id: this.props.user.personnel_id,
            institution_id: this.props.institution._id,
          }).then((res) => {
            console.log("After created by personnel: ", res?.data)
            API.updateCampus({
              ...updatingData,
              _id: res?.data?._id
            }).then((response) => {
              console.log("Updated campus: ", response)
              this.props.createCampus(response?.data);
              const msg = "Campus created successfully by personnel";
              notify.show(msg);

              setTimeout(() => {
                window.location.reload();
              }, 700)
            })
          });
        } 
      }
      else {
        API.updateCampus(updatingData).then((response) => {
          console.log("Updated campus 2: ", response)
          this.props.updateCampus(response?.data);
          setTimeout(() => {
            window.location.reload();
          }, 700)
        })
      }
      
      // .then((result) => {
      //   console.log("updateCampus: ", result, this.state.current_campus?.temp_id)
      // });

      // this.props.setTabPairs();

      API.instProgressEmail({
        inst_id: this.props.user.institution_id || this.props.user.institution,
        email_address: this.props.user.email || this.props.user.personnel_email,
        etype: "CPS_CONF",
      })
        .then((result) => {
          console.log("email result:", result);
          notify.show("Campus updated successfully")
          // setTimeout(() => window.location.reload(), 1000)
        })
        .catch((err) => {
          console.log("err:", err);
        });
    }
  };

  handleDelete = (e) => {
    e.preventDefault()
    if (!this.props.user.permissions) {
      this.props.deleteCampus({
        campus_id: this.state.current_campus._id,
        customer_id: this.props.user.customer_id,
        fullcontrol: true,
      });
    } else {
      this.props.deleteCampus({
        campus_id: this.state.current_campus._id,
        personnel_id: this.props.user.personnel_id,
        fullcontrol: false,
      });
    }
    this.setState(
      {
        isShowing: false,
      },
      () => {
        setTimeout(() => {
          localStorage.setItem("campus-Index", 0);
          window.location.reload();
        }, 700)
      }
    );
  };

  openModal = (e) => {
    this.setState({ isShowing: true });
  };
  closeModal = (e) => {
    this.setState({ isShowing: false });
  };

  handleChangeCarParkingLocation = (newLocation) => {
    this.setState((prevState) => {
      return {
        ...prevState,
        edited: true,
        car_parking_location: {
          ...prevState.car_parking_location,
          ...newLocation
        }
      };
    })
  };

  handleSelectAddressFromSuggestions = (address) => {
    if (!address) return

    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${GOOGLE_MAP_API_KEY}`;

    axios.get(url)
      .then((response) => {
        const data = response.data;

        if (data?.results?.length > 0) {
          const addressObj = data.results[0];
          const coord = {
            lat: parseFloat(addressObj.geometry.location.lat),
            lng: parseFloat(addressObj.geometry.location.lng),
          };

          this.setState((prevState) => ({
            edited: true,
            car_parking_location: {
              ...prevState.car_parking_location,
              ...coord,
            },
            current_coords: coord,
          }));
        }
      })
      .catch(err => {
        console.log(`⚡️[log]: Error:`, err);
      });
  }

  render() {
    return (
      <div className="row college-info">
        <div className="col-lg-6 col-md-12 column-fix">
          <div className="row">
            <FormField
              label="Building Level/ Floor"
              id="floor_no"
              className='col-md-4 px-0 px-md-3'
              value={this.state.floor_no}
              onChange={this.handleFormFieldChange}
              placeholder="Floor Number Only"
              required
            />

            <FormField
              label="Address Line 1"
              id="address_line1"
              className="col-md-8 px-0 px-md-3"
              value={this.state.address_line1}
              onChange={this.handleFormFieldChange}
              placeholder="Address Line 1"
              required
            />
          </div>

          <div className="row">
            <FormField
              label="Address Line 2"
              id="address_line2"
              className="col-md-8 px-0 px-md-3"
              placeholder="Address Line 2"
              value={this.state.address_line2}
              onChange={this.handleFormFieldChange}
            />

            <FormField
              label="Suburb"
              id="suburb"
              className="col-md-4 px-0 px-md-3"
              required
              value={this.state.suburb}
              onChange={this.handleFormFieldChange}
              placeholder="Suburb"
            />
          </div>

          <div className="row">
          <FormDropdown
            label="Country"
            id="country"
            className="col-md-4 px-0 px-md-3"
            required
            placeholder="Country name"
            value={this.state.country}
            onChange={this.onSelectCountry}
          >
            
            <option value="">Please Choose</option>
            {countries.map((country) => {
              if(this.state.country === country.name) {
                return <option value={country.name}>{country.name}</option>
              }
              else return <option value={country.name}>{country.name}</option>;
            })}
            
          </FormDropdown>

            <FormField
              label="Postcode"
              id="postcode"
              className="col-md-4 px-0 px-md-3"
              required
              value={this.state.postcode}
              onChange={this.handleFormFieldChange}
              placeholder="Postal code"
            />

            <FormDropdown
            label="State/Province"
            id="state"
            className="col-md-4 px-0 px-md-3"
            required
            value={this.state.state}
            onChange={this.handleFormFieldChange}
          >
            <option value="" hidden>Please Choose</option>
            { this.state.cities.map((city) => {
                if(this.state.state === city.name) {
                  return <option value={city.name}>{city.name}</option>
                }
               else {
                return <option value={city.name}>{city.name}</option>
              }
            })}
          </FormDropdown>
          </div>

          <div className="row">
            <div className="col-md-12 column-fix">
              <label htmlFor="timezone">Timezone</label>
              <TimezoneSelect
                id="timezone"
                value={this.state.timezone.split(" ")[1] || this.state.timezone}
                onChange={(timezone) => {
                  this.setState({
                    timezone: timezone.label.split(" ")[0] + " " + timezone.value,
                    edited: true
                  });
                }}
                className="p-0"
              />
            </div>
          </div>
        </div>

        <div className="col-lg-6 col-md-12 column-fix">
          <FormField
            label={this.props.user?.is_childcare_centre ? "Centre arrival note" : "Campus arrival note"}
            id="note_gcal"
            value={this.state.note_gcal}
            onChange={this.handleFormFieldChange}
            placeholder={this.props.user?.is_childcare_centre ? `"Use doorbell at entry"` : `"E.g.: Report to security to obtain a building day pass"`}
          />
          <div className="row align-items-end">
            <div className="col-md-6 column-fix">
              <FormField
                label="Person to report"
                id="report_to"
                value={this.state.report_to}
                onChange={this.handleFormFieldChange}
                placeholder="Manager or Coordinator"
                required
              />
            </div>
            <div className="col-md-6 column-fix">
              <FormField
                label={
                  this.props.user?.is_childcare_centre 
                  ? "Add reception or admin for booking notification" 
                  : "Add campus manager, reception or security email for booking notifications"
                }
                id="extra_booking_email"
                type="text"
                value={this.state.extra_booking_email}
                onChange={this.handleFormFieldChange}
                placeholder="Email a copy of the booking confirmation"
              />
            </div>
          </div>

          {/* add justify-content-start to button container for error log 69 */}
          {
            !this.props.user?.is_childcare_centre && (
              <ButtonContainer
                label="Classes at this campus"
                className="w-100 row flex-row justify-content-around mx-0"
              >
                {/* change col-md-3 to 4 for error log 69 */}

                <div className="col-md-4 column-fix pl-0">
                  <CheckableButton
                    checkbox
                    id="departments-elicos"
                    name="departments"
                    title="ELICOS"
                    className="campus-departments-checkbox"
                    onChange={this.handleDepartmentChange}
                    checked={this.state.departments.includes("ELICOS")}
                  >
                    ELICOS
                  </CheckableButton>
                </div>
                <div className="col-md-4 column-fix">
                  <CheckableButton
                    checkbox
                    id="departments-vet"
                    name="departments"
                    title="VET"
                    className="campus-departments-checkbox"
                    onChange={this.handleDepartmentChange}
                    checked={this.state.departments.includes("VET")}
                  >
                    VET
                  </CheckableButton>
                </div>
                <div className="col-md-4 column-fix pr-0">
                  <CheckableButton
                    checkbox
                    id="departments-vet-other"
                    name="departments"
                    title="VET Other"
                    className="campus-departments-checkbox"
                    onChange={this.handleDepartmentChange}
                    checked={this.state.departments.includes("VET Other")}
                  >
                    VET Other
                  </CheckableButton>
                </div>
                {/* is this needed? */}
                {/* <div className="col-md-3"></div> */}
              </ButtonContainer>
            )
          }

          <div className="row">
            <FormField
              label={this.props.user?.is_childcare_centre ? "Save centre under a shortname" : "Save campus under a shortname"}
              id="reference_name"
              className="col-md-6 column-fix"
              maxLength={7}
              value={
                this.state.reference_name === "unnamed"
                  ? Placeholder
                  : this.state.reference_name
              }
              onChange={this.handleFormFieldChange}
              placeholder="E.g.: Melb (Max 5 characters)"
              required
            />
          </div>
          
          {
            this.props.user?.is_childcare_centre && (
              <div className="row">
                <div className="col-lg-12">
                  <ButtonContainer label="Car Parking" className="w-100 row flex-row p-0" >
                    <div className="col-md-6">
                      <CheckableButton
                        checkbox
                        id="on_site"
                        name="on_site"
                        title="On-site (free)"
                        className="campus-departments-checkbox"
                        onChange={this.handleCarParkingChange}
                        checked={
                          this.state.car_parking === "On-site (free)"
                        }
                      >
                        On-site (free)
                      </CheckableButton>
                    </div>
                    < div className="col-md-6">
                      <CheckableButton
                        checkbox
                        id="on_street"
                        name="car-parking"
                        title="On-street (free)"
                        className="campus-departments-checkbox"
                        onChange={this.handleCarParkingChange}
                        checked={
                          this.state.car_parking === "On-street (free)"
                        }
                      >
                        On-street (free)
                      </CheckableButton>
                    </div>
                    < div className="col-md-6">
                      <CheckableButton
                        checkbox
                        id="walk_to_centre"
                        name="car-parking"
                        title="On-street, walk to centre (free)"
                        className="campus-departments-checkbox"
                        onChange={this.handleCarParkingChange}
                        checked={
                          this.state.car_parking === "On-street, walk to centre (free)"
                        }
                      >
                        On-street, walk to centre (free)
                      </CheckableButton>
                    </div>
                    <div className="col-md-6">
                      <CheckableButton
                        checkbox
                        id="paid_car_park"
                        name="car-parking"
                        title="Paid car park"
                        className="campus-departments-checkbox"
                        onChange={this.handleCarParkingChange}
                        checked={
                          this.state.car_parking === "Paid car park"
                        }
                      >
                        Paid car park
                      </CheckableButton>
                    </div>
                  </ButtonContainer>

                  {
                    this.state.car_parking && (
                      <Button
                        className="mb-2 text-capitalize font-weight-normal"
                        variant="text"
                        onClick={() => {
                          this.setState({
                            car_parking: '',
                            car_parking_location: {
                              address: "",
                              lat: 0,
                              lng: 0,
                              detail: "",
                            }
                          })
                        }}
                      >
                        <u>Clear Selection</u>
                      </Button>
                    )
                  }
                </div>

                {
                  this.state.car_parking && this.state.car_parking !== "On-site (free)" && (
                    <>
                      <div className="col-lg-12">
                        <GoogleMapsAutocomplete
                          address={this.state?.car_parking_location?.address}
                          onChangeAddress={(address) => {
                            this.setState((prevState) => ({
                              edited: true,
                              car_parking_location: {
                                ...prevState.car_parking_location,
                                address: address,
                              },
                            }));
                          }}
                          onSelectAddress={(address) => this.handleSelectAddressFromSuggestions(address)}
                        />
                      </div>

                      <div className="col-lg-12 mt-3">
                        <FormField
                          id="detail"
                          className="col-md-8 px-0"
                          placeholder="Detail"
                          value={this.state?.car_parking_location?.detail || ""}
                          onChange={(e) => this.handleChangeCarParkingLocation({detail: e.target.value})}
                        />
                      </div>
                    </>
                  )
                }
              </div>
            )
          }
        </div>

        {
          this.props.user?.is_childcare_centre && this.state.car_parking && this.state.car_parking !== "On-site (free)" && (
            <div className="row col-md-12 pt-6 column-fix">
              <GgMap
                currentCoord={this.state.current_coords}
                // setCarParkingLocation={this.handleChangeCarParkingLocation}
              />
            </div>
          )
        }

        <div className="row col-md-12 pt-6 column-fix">
          <div className="col-md-6 column-fix">
            <CancelButton
              type="button"
              className="college_delete_campus "
              hidden={!this.props.editcampus || !this.state.editthiscampus}
              //disabled
              onClick={this.openModal}
            >
              Delete
            </CancelButton>
          </div>

          <div className="col-md-6 column-fix">
            <ConfirmButton
              type="button"
              className="college_submit "
              hidden={!this.props.editcampus || !this.state.editthiscampus}
              disabled={!this.state.edited}
              onClick={
                // (this.props.editcampus && this.state.editthiscampus) ?
                this.handleSubmit
                // : (e) => {
                //   e.preventDefault()
                //   notify.show("Please contact your manager to acquire access to delete campus")
                // }
              }
            >
              Submit
            </ConfirmButton>
          </div>
        </div>

        <Modal
          className="confirm-delete"
          header="Do you wish to delete?"
          show={this.state.isShowing}
          onClose={this.closeModal}
        >
          <div className="row m-0">
            <div className="col-md-6">
              <CancelButton type="button" onClick={this.closeModal}>
                Cancel
              </CancelButton>
            </div>
            <div className="col-md-6 padding-for-mobile">
              <ConfirmButton type="button" onClick={this.handleDelete}>
                Yes and Proceed
              </ConfirmButton>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

// function mapStateToProps(state) {
//   return {
//     campuses: state.college.campuses
//   }
// }

const mapDispatchToProps = (dispatch) => ({
  // For Desktop use
  createCampus: (campusData) => dispatch(createCampus(campusData)),
  addCampusToPersonnel: (campusData) =>
    dispatch(addCampusToPersonnel(campusData)),
  updateCampus: (campusData) => dispatch(updateCampus(campusData)),
  deleteCampus: (campusData) => dispatch(deleteCampus(campusData)),
});

export default connect(null, mapDispatchToProps, null, { forwardRef: true })(
  Campus2
);
